
import { TimeManagementKeys } from '@/i18n/types';

export const timeManagement: Record<TimeManagementKeys, string> = {
  timeManagement: 'Gestión del Tiempo',
  schedule: 'Agenda',
  timeDesc: 'Organiza tu tiempo de manera eficiente con nuestras herramientas de gestión temporal.',
  pomodoroTimer: 'Técnica Pomodoro',
  startTimer: 'Iniciar Temporizador',
  pauseTimer: 'Pausar Temporizador',
  resetTimer: 'Reiniciar Temporizador',
  work: 'Trabajo',
  shortBreak: 'Descanso Corto',
  longBreak: 'Descanso Largo',
  focusTime: 'Tiempo de Enfoque',
  breakTime: 'Tiempo de Descanso',
  workTime: 'Tiempo de Trabajo',
  addEvent: 'Añadir Evento',
  eventTitle: 'Título del Evento',
  startTime: 'Hora de Inicio',
  endTime: 'Hora de Fin',
  addSpecialDate: 'Añadir Fecha Especial',
  specialDateTitle: 'Título de Fecha Especial',
  specialDateType: 'Tipo de Fecha Especial',
  specialDatesTitle: 'Fechas Especiales',
  birthday: 'Cumpleaños',
  anniversary: 'Aniversario',
  reminder: 'Recordatorio',
  holiday: 'Festivo',
  other: 'Otro',
  weekly: 'Semanal',
  daily: 'Diario',
  monthly: 'Mensual',
  weeklySchedule: 'Agenda Semanal',
  weekOf: 'Semana del',
  time: 'Hora',
  workComplete: 'Sesión de Trabajo Completada',
  breakComplete: 'Descanso Completado',
  timeForABreak: '¡Tiempo para un breve descanso!',
  timeToFocus: '¡Tiempo para volver a concentrarse!',
  toggleSound: 'Activar/Desactivar Sonido',
  viewAllSpecialDates: 'Ver Todas las Fechas Especiales',
  viewAllSpecialDatesDesc: 'Ver y gestionar todas tus fechas especiales en un solo lugar.',
  allSpecialDates: 'Todas las Fechas Especiales',
  date: 'Fecha',
  title: 'Título',
  type: 'Tipo',
  actions: 'Acciones',
  edit: 'Editar',
  delete: 'Borrar',
  specialDateDeleted: 'Fecha especial eliminada con éxito',
  errorDeletingSpecialDate: 'Error al eliminar la fecha especial',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  viewMode: 'Modo de Vista',
  dailyView: 'Vista Diaria',
  weeklyView: 'Vista Semanal',
  monthlyView: 'Vista Mensual',
  yearlyView: 'Resumen Anual',
  dailySchedule: 'Agenda Diaria',
  monthlySchedule: 'Agenda Mensual',
  repeatsAnnually: 'Repetición Anual',
  repeatsAnnuallyDesc: 'Esta fecha se mostrará cada año',
  noSpecialDates: 'No se encontraron fechas especiales',
  loading: 'Cargando...',
  timeBlocks: 'Bloques de Tiempo',
  analytics: 'Análisis',
  templates: 'Plantillas',
  annualCalendar: 'Calendario Anual'
};
